import {
  Box,
  Flex,
  HStack,
  Spacer,
  Stack,
  createListCollection,
} from "@chakra-ui/react";
import * as React from "react";
import { useEffect } from "react";
import {
  LuLogOut,
  LuSettings,
  LuSettings2,
  LuTarget,
  LuUsers,
} from "react-icons/lu";
import { Outlet, useNavigate } from "react-router-dom";

import AppShell from "../components/app-shell";
import { Logo } from "../components/logo";
import NavItem from "../components/nav-item";
import {
  SelectContent,
  SelectItem,
  SelectRoot,
  SelectTrigger,
  SelectValueText,
} from "../components/select";
import Sidebar from "../components/sidebar";
import SidebarSection from "../components/sidebar-section";
import { Toaster } from "../components/toaster";
import { useAppSelector, useWorkspaceURL } from "../hooks";

export default function Root() {
  const navigate = useNavigate();
  const workspaceURL = useWorkspaceURL();
  const user = useAppSelector((state) => state.auth.user);
  const currentSlug = useAppSelector((state) => state.workspace.slug);
  useEffect(() => {
    if (user === null) {
      navigate("/login");
    }
  }, [navigate, user]);

  const workspaces = React.useMemo(() => {
    const workspaces = user?.workspaces ?? [];
    return createListCollection({
      items: workspaces.map((ws) => ({ value: ws.slug, label: ws.name })),
    });
  }, [user]);
  const handleWorkspaceChange = (e: { value: string[] }) => {
    const slug = e.value[0];
    navigate(`/workspaces/${slug}`);
  };

  return (
    <AppShell>
      <Stack flex="1" gap="0">
        <HStack align="top" flex="1" gap="0">
          <Sidebar>
            <Box pt="2" pl="2" h="20">
              <Logo height="20" />
            </Box>
            <Box px="2" pb="2">
              <SelectRoot
                value={currentSlug ? [currentSlug] : []}
                onValueChange={handleWorkspaceChange}
                collection={workspaces}
                size="sm"
                variant="workspace"
              >
                <SelectTrigger>
                  <SelectValueText />
                </SelectTrigger>
                <SelectContent>
                  {workspaces.items.map((ws) => (
                    <SelectItem key={ws.value} item={ws}>
                      {ws.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </SelectRoot>
            </Box>
            <SidebarSection pt="0">
              <NavItem
                icon={<LuSettings2 />}
                to={workspaceURL("conversion-events")}
              >
                Conversion Events
              </NavItem>
              <NavItem icon={<LuTarget />} to={workspaceURL("retargeting")}>
                Retargeting
              </NavItem>
              <NavItem icon={<LuUsers />} to={workspaceURL("audiences")}>
                Audiences
              </NavItem>
            </SidebarSection>
            <Spacer />
            <SidebarSection>
              <NavItem icon={<LuSettings />} to={workspaceURL("settings")}>
                Settings
              </NavItem>
              <NavItem icon={<LuLogOut />} href="/logout">
                Logout
              </NavItem>
            </SidebarSection>
          </Sidebar>
          <Flex flex="1" px="4" pt="4">
            <Outlet />
          </Flex>
        </HStack>
      </Stack>
      <Toaster />
    </AppShell>
  );
}
